import React, { useEffect } from 'react';
import { LinkStyles } from '../../theme';
import { Link } from '@mui/material';
import { StyledOutOfNetwork } from './styles';
import { Network, PlanService, SelectedNetwork } from '../../utils/types';
import HMOOutOfNetwork from './HMOOutOfNetwork';
import StartOverButton from '../StartOverButton';
import { EventAction, trackMixpanelEvent } from '../../mixpanelAnalytics';

const OutOfNetwork = (): JSX.Element => (
    <StyledOutOfNetwork>
        <div style={{ padding: '0.5rem 2rem' }}>
            <h3 style={{ fontSize: '1.5rem' }}>Sorry, we are out of network.</h3>
            <div style={{ marginLeft: '1.5rem', fontSize: '1.2rem' }}>
                <p>
                    If you believe this message to be in error, call your insurance and ask if you are in network with <span style={LinkStyles}>Perlman Clinic - Tax ID: 20-2138632</span> or <span style={LinkStyles}>83-2310783</span>.<br/>
                    You may also ask your insurance plan about out-of-network benefits.
                </p>
                <p>
                    Alternatively, call our billing department at (858) 554-1212.<br/>
                    Please note we accept patients on a cash-pay basis. Check out our self-pay pricing <Link href='https://perlmanclinic.com/pricing/' style={LinkStyles} target="new">here</Link>. If you do self-pay, we are happy to provide you notes and an itemized receipt so you can try to be reimbursed by your insurance company.
                </p>
            </div>
        </div>
    </StyledOutOfNetwork>
);

type Props = {
    service: PlanService | undefined;
    network: SelectedNetwork | undefined;
    handleStartOver: () => void;
}

const OutOfNetworkContainer = ({ service, network, handleStartOver }:Props): JSX.Element => {
    useEffect(() => {
        trackMixpanelEvent(EventAction.NETWORK_STATUS, { status: 'Out of Network' });
    }, []);
    const hmoOutOfNetworkMessageServices = [ 'Primary Care', 'Urgent Care', 'Endocrinology' ];
    if (service?.name && hmoOutOfNetworkMessageServices.includes(service?.name) && network?.network === Network.HMO) {
        return (<HMOOutOfNetwork handleStartOver={handleStartOver}/>);
    }
    return (
        <>
            <OutOfNetwork/>
            <StartOverButton handleStartOver={handleStartOver}/>
        </>
    );
};

export default OutOfNetworkContainer;
